import React from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import TeamCpdTab from './TeamCpdTab';

interface TeamCpdDialogProps {
  open: boolean;
  onClose: () => void;
  /** True for admins — unlocks the "view any team" picker. */
  isAdmin?: boolean;
}

/**
 * "Team CPD Status" — a district director's own slice of the CPD dashboard, scoped to
 * their downline via `User.ManagerUserId`. Sits under CPD Analytics in the
 * sidebar; access is granted to admins and the eligible district-director
 * designations, and enforced again by the backend on every request.
 */
const TeamCpdDialog: React.FC<TeamCpdDialogProps> = ({ open, onClose, isAdmin = false }) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="lg"
    fullWidth
    PaperProps={{
      sx: {
        bgcolor: 'var(--color-surface)',
        color: 'var(--color-text-strong)',
        minHeight: '80vh',
      },
    }}
  >
    <DialogTitle sx={{ borderBottom: '1px solid rgba(var(--color-text-rgb), 0.08)' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 2 }}>
        <Box>
          <Typography variant="h6">Team CPD Status</Typography>
          <Typography variant="body2" sx={{ color: 'rgba(var(--color-text-rgb), 0.72)' }}>
            CPD fulfilment across the whole team — every tier down the reporting line.
          </Typography>
        </Box>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </Box>
    </DialogTitle>

    <DialogContent sx={{ pt: 2.5 }}>
      <TeamCpdTab isAdmin={isAdmin} />
    </DialogContent>

    <DialogActions sx={{ borderTop: '1px solid rgba(var(--color-text-rgb), 0.08)' }}>
      <Button onClick={onClose}>Close</Button>
    </DialogActions>
  </Dialog>
);

export default TeamCpdDialog;
